import styled from '@emotion/styled';
import CloseIcon from '~/icons/close-thin.svg';

export const StyledList = styled.ul(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    margin: `${theme.space[2]} 0`,
}));

const StyledLi = styled.li(({ theme }) => ({
    fontFamily: theme.fonts.roboto,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '100%',
    letterSpacing: '0.28px',
    textAlign: 'center',
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.space[2],
    padding: '10px',
    borderRadius: 9999,
    cursor: 'pointer',

    '&:not(:last-of-type)': {
        marginRight: theme.space[2],
    },
}));

export const StyledClearAll = styled(StyledLi)(({ theme }) => ({
    border: `1px solid ${theme.colors.brandBeigeMedium}`,
    color: theme.colors.black,

    '&:hover': {
        borderColor: theme.colors.brownMedium,
    },

    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledFacet = styled(StyledLi)(({ theme }) => ({
    background: theme.colors.brandBeigeMedium,
    color: theme.colors.black,

    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
    width: 16,
    height: 16,
    marginLeft: theme.space[1],
    marginRight: `-${theme.space[1]}`,
}));

export const StyledSwatch = styled.span(({ theme }) => ({
    display: 'flex',
    marginRight: theme.space[1],
}));
